<template>
  <div class="container">
    <div class="preloader" v-if="!dataLoaded">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <div class="live-search">
      <form class="input-wrapper" @submit.prevent="search()">
        <input v-model="searchWord" type="text" class="search-field" placeholder="Поиск">
        <button class="searchBTn" type="submit">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.414776 7.28696L0.414777 7.28695C1.42109 3.51365 4.43058 0.823287 8.32008 0.222054C9.39854 0.0554034 11.1694 0.186939 12.3261 0.521827C15.5588 1.45784 18.0602 4.04802 18.913 7.34519C19.2417 8.61632 19.2636 10.6393 18.9633 11.8403C18.8522 12.2846 18.6248 12.9001 18.3627 13.4965C18.1004 14.0933 17.8086 14.6593 17.5722 15.0069L17.2606 15.465L17.1911 15.5673L17.2782 15.6551L19.5205 17.913C20.1361 18.5329 20.7046 19.127 21.1246 19.5845C21.3348 19.8134 21.5068 20.0071 21.6286 20.1522C21.6897 20.225 21.7369 20.2841 21.7696 20.3285C21.786 20.3508 21.7977 20.3678 21.8052 20.3801C21.8083 20.3851 21.8102 20.3884 21.8111 20.3902C21.9233 20.7674 21.7835 21.1731 21.4991 21.4662C21.2134 21.7608 20.8042 21.9183 20.412 21.8212C20.4125 21.8214 20.4122 21.8212 20.4111 21.8208C20.4066 21.8187 20.3871 21.8098 20.3476 21.784C20.3041 21.7555 20.2475 21.7141 20.1779 21.6593C20.0391 21.5499 19.8558 21.3927 19.6335 21.1925C19.1894 20.7924 18.596 20.2257 17.9035 19.5376L15.6456 17.2941L15.5579 17.207L15.4557 17.2764L15.1005 17.5173L15.1848 17.6414L15.1005 17.5173C12.5857 19.2236 9.43886 19.6558 6.56286 18.6901C3.41625 17.6336 1.02351 14.9318 0.29546 11.6073L0.295458 11.6072C0.178741 11.0744 0.133121 10.2741 0.155518 9.46072C0.177905 8.64771 0.26779 7.83805 0.414776 7.28696ZM2.43362 10.1139L2.58316 10.1022L2.43362 10.1139C2.73625 13.9946 5.83226 16.8951 9.66371 16.878C11.6547 16.8691 13.3558 16.1641 14.7534 14.7677L14.7535 14.7677C16.1553 13.3668 16.8611 11.6636 16.8611 9.68118C16.8611 7.70213 16.1503 5.97528 14.762 4.58415L14.6559 4.6901L14.762 4.58415C13.8738 3.69406 13.1483 3.24533 11.9093 2.81788C10.8298 2.44542 9.3066 2.35191 8.17473 2.58794L8.17473 2.58795C4.72299 3.30797 2.16415 6.65755 2.43362 10.1139Z" fill="black" stroke="white" stroke-width="0.3"/>
          </svg>
        </button>
        <div 
          class="search-result" 
          v-click-outside="onClickOutside"
          :class="{show: searchShow}">
          <p
            @click="goToProductCard(item)"
            v-for="(item, index) in searchResult" 
            :key="index"
            class="search-result__item"
          >{{item.name}}</p>
        </div>
      </form>
    </div>
    <div class="product-list">
        <div 
            v-for="(product, index) in productList" 
            :key="index" 
            class="product-list__item"
            @click="goToProduct(product)"
        >
            <p class="name">{{product.name}}</p>
            <img :src="product.picture" alt="">
        </div>
    </div>
    <p v-if="isCartNoEmpty" class="createOrder-btn" @click="toCart()">Перейти в корзину</p>
  </div>
</template>
<script>
export default {
  data: () => ({
    productList: [],
    dataLoaded: false,
    searchWord: '',
    searchResult: [],
    searchShow: false
  }),
  methods: {
    onClickOutside(){
      this.searchShow = false;
    },
    startComponent() {
      let data = {
          shopName: this.$route.params.shopName,
          parentID: this.$route.params.id || 0
      }
      // Получить список каталогов
      this.$store
        .dispatch("GET_SHOP_CATALOG_LIST", data)
        .then((response) => {
          if (response.data.status != "success") {
            this.$makeToast(
              "Упс!",
              "danger",
              "Почему-то с сервера не пришел список товаров:(",
              5000
            );
          } else {
            this.productList = response.data.data;
            this.dataLoaded = true;
          }
        });
    },
    goToProduct(product){

        if(product.isChilds != 0 && !this.$route.params.id){
            this.$router.push('/shop/'+this.$route.params.shopName + '/' + product.id);
            this.startComponent();
        }else{
            this.$router.push('/shop/chess/'+this.$route.params.shopName+'/'+product.id);
        }
    },
    toCart(){
      console.log(this.$route.params)
      this.$router.push('/' + this.$route.params.shopName + '/shop-cart')
    },
    toggleSearchResult(){
      this.searchShow = !this.searchShow;
    },
    search(){
      let data = {
        shopName: this.$route.params.shopName,
        q: this.searchWord
      }
      this.$store.dispatch('SHOP_SEARCH', data).then(response => {
        this.searchResult = response.data.data;
        if(this.searchResult.length != 0){
          this.toggleSearchResult();
        }
      })
    },
    goToProductCard(item){
      let data = {
        collectionID: item.categoryId,
        shopName: this.$route.params.shopName
      }
      this.dataLoaded = false
      this.$store.dispatch('GET_CATALOG_LIST_SHOP', data).then(r => {
        this.$localStorageSet('currentCollection', r.data.data)
        this.$router.push('/shop/'+this.$route.params.shopName+'/'+item.categoryId+'/'+item.id)
        this.dataLoaded = true
      })
    }
  },
  computed: {
    isCartNoEmpty: function () {
      //Показать кнопку оформить заказ если в корзине что-то есть
      let miniCart = this.$localStorageGet("miniCart");
      return Object.keys(miniCart).length == 0 ? false : true;
    },
  },
  created() {
    this.startComponent();
  },
  watch: {
      '$route'(){
          this.startComponent();
      }
  }
};
</script>
<style lang="scss" scoped>
    a {
        width: 100%;
        display: flex;
        font-weight: 500;
        font-size: 14px;
        color: #000;
        text-transform: uppercase;
        height: 45px;
        align-items: center;
        justify-content: center;
        background: #c4c4c4;
        margin-bottom: 15px;
    }

    .title {
        font-weight: bold;
        font-size: 24px;
        line-height: 35px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        text-align: center;
        padding-top: 35px;
        padding-bottom: 25px;
    }

    .product-list{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .product-list__item{
        width: 100%;
        max-width: 295px;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        p{
            width: 100%;
            text-transform: uppercase;
            font-size: 18px;
            font-weight: bold;
            padding-bottom: 5px;

        }
        img{
            width: 100%;
            height: auto;
        }
    }

    .createOrder-btn {
      width: 100%;
      border: 1px solid black;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      bottom: 5px;
      background: #000;
      color: #fff;
      max-width: 340px;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
    .input-wrapper{
      height: 100%;
      display: flex;
      position: relative;
    }
    .searchBTn{
      height: 50px;
      width: 50px;
      background: none;
      border: none;
      border-bottom: 3px solid #dcdcdc;
      &:focus{
        outline: none;
      }
    }
    .live-search{
      width: 100%;
      height: 50px;
      margin-top: 20px;
      margin-bottom: 20px;
      .search-field{
        width: calc(100% - 50px);
        height: 100%;
        border: none;
        border-bottom: 3px solid #dcdcdc;
        padding: 0 15px;
        &:focus{
          outline: none;
        }
      }
    }
    .search-result{
      position: absolute;
      width: 100%;
      border: 1px solid #dcdcdc;
      top: 100%;
      background: #fff;
      z-index: 2;
      flex-direction: column;
      max-height: 300px;
      overflow: auto;
      display: none;
      &.show{
        display: flex;
      }
      .search-result__item{
        min-height: 50px;
        padding-left: 10px;
        display: flex;
        align-items: center;
        font-size: 12px;
        &:not(:last-child){
          border-bottom: 1px solid #dcdcdc;
        }
      }
    }
</style>